module.exports = __webpack_public_path__ + "shanz/static/media/placeholder.0b0db852.gif";